export type RoleName = 'admin' | 'negotiations' | 'accounting' | 'general' | 'superadmin' | null;

const MODULE_KEYS = ['dashboard', 'negotiations', 'accounts', 'payments', 'reports', 'settings', 'notifications', 'superadmin'] as const;
export type ModuleKey = (typeof MODULE_KEYS)[number];

export interface AuthUser {
    id: number;
    creditor_id: number | null;
    name: string;
    email: string;
    role_name: RoleName;
    should_show_product_tour?: boolean;
}

const ROLE_MODULES: Record<Exclude<RoleName, null>, readonly ModuleKey[]> = {
    admin: ['dashboard', 'negotiations', 'accounts', 'payments', 'reports', 'settings', 'notifications'],
    negotiations: ['dashboard', 'negotiations', 'accounts', 'reports', 'notifications'],
    accounting: ['dashboard', 'accounts', 'payments', 'reports', 'notifications'],
    // PHASE1: general role per server-api.md — no settings, no notifications.
    general: ['dashboard', 'negotiations', 'accounts', 'payments', 'reports'],
    superadmin: ['superadmin', 'dashboard', 'negotiations', 'accounts', 'payments', 'reports', 'settings', 'notifications'],
} as const;

const MODULE_ROUTE_NAMES = Object.fromEntries(
    MODULE_KEYS.map((key) => [key, key]),
) as Record<ModuleKey, ModuleKey>;

export function resolveAllowedModules(roleName: RoleName): ModuleKey[] {
    if (!roleName) return [];
    return [...(ROLE_MODULES[roleName] ?? [])];
}

export function canAccessModule(roleName: RoleName, module: ModuleKey): boolean {
    return resolveAllowedModules(roleName).includes(module);
}

export function pickFallbackRouteName(roleName: RoleName): string | null {
    const allowed = resolveAllowedModules(roleName);
    if (allowed.length === 0) return null;
    if (allowed.includes('superadmin')) return 'superadmin-creditors';
    if (allowed.includes('dashboard')) return MODULE_ROUTE_NAMES.dashboard;
    return MODULE_ROUTE_NAMES[allowed[0]];
}
